a
<template>
  <b-modal id="modal-detail" size="xl" centered scrollable :title="title" header-bg-variant="primary" header-text-variant="light">
    <div>
      <!-- <b-row>
        <b-col cols="12" md="12" lg="12">
          <h4><strong>Data Absensi Kedatangan</strong></h4>
          <hr />
        </b-col>
      </b-row> -->

      <!-- <b-row class="mt-3">
        <b-col md="3">
          <b-form-group
            :label="$store.state.table.perHalaman"
            label-for="per-page-select"
            label-cols-md="6"
            label-align-md="left"
            label-size="md"
            style="background-color: "
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="md"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="6" offset-md="3">
          <b-form-group
            :label="$store.state.table.cari"
            label-for="filter-input"
            label-cols-md="3"
            label-align-md="right"
            label-size="md"
          >
            <b-input-group size="md">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$store.state.table.cariHolder"
              ></b-form-input>

              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                  variant="danger"
                  >{{ $store.state.table.hapusCari }}</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row> -->

      <b-row>
        <b-col cols="12" md="12" lg="12">
          <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
            <template #statusIjin="{ item }">
              <td>
                <span v-if="item.statusIjin == 0 && item.kategoriShift == 'Dayoff'">DAY OFF</span>
                <span v-else-if="item.statusIjin == 0">BERANGKAT</span>
                <span v-else-if="item.statusIjin == 1">CUTI</span>
                <span v-else-if="item.statusIjin == 2">DINAS</span>
                <span v-else-if="item.statusIjin == 3">CUTI HAMIL</span>
                <span v-else-if="item.statusIjin == 4">IJIN</span>
                <span v-else-if="item.statusIjin == 5">SAKIT</span>
                <span v-else-if="item.statusIjin == 6">ALPHA / MANGKIR</span>
                <span v-else-if="item.statusIjin == 7">KELUARGA MENINGGAL</span>
                <span v-else-if="item.statusIjin == 8">ISTRI MELAHIRKAN</span>
                <span v-else-if="item.statusIjin == 9">MENIKAH</span>
                <span v-else-if="item.statusIjin == 10">JATAH LIBUR</span>
              </td>
            </template>
            <template #kodeDendaAbsen="{ item }">
              <td>
                <p v-if="item.kategoriShift && item.kategoriShift.toLowerCase() === 'dayoff'" class="text-secondary fw-semibold mb-0">DAY OFF</p>
                <p v-else-if="(!item.masuk || item.masuk === '') && new Date(item.tanggalAbsen) < new Date()" class="text-danger fw-semibold mb-0">ABSEN TIDAK LENGKAP</p>
                <p v-else-if="!item.masuk || item.masuk === ''" class="text-warning fw-semibold mb-0">KARYAWAN BELUM ABSEN</p>
                <p v-else-if="item.kodeDendaAbsen === 0" class="text-success fw-semibold mb-0">ON TIME</p>
                <p v-else-if="item.kodeDendaAbsen === 1" class="text-primary fw-semibold mb-0">TELAT 10 MENIT</p>
                <p v-else-if="item.kodeDendaAbsen === 2" class="text-info fw-semibold mb-0">TELAT 60 MENIT</p>
              </td>
            </template>
            <template #terlambat="{ item }">
              <td>
                <span v-if="item.terlambat > 0">{{ item.terlambat }} Menit</span>
              </td>
            </template>
            <template #actions="{ item }">
              <td>
                <b-button
                  v-b-modal.modal-foto
                  class="mr-1"
                  v-c-tooltip.hover.click="'Foto Data'"
                  @click="(src1 = item.fotoAbsensi ? viewImage(item) : null), item.fotoAbsensiKeluar ? (src2 = viewImage(item.fotoAbsensiKeluar)) : null"
                  ><CIcon name="cil-file"
                /></b-button>
                <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="'Edit Data'" v-b-modal.modal-telat @click="dataEdit = item"><CIcon name="cil-pencil" /></b-button>
                <!-- <b-button variant="info" v-c-tooltip.hover.click="'Log Absen'" v-b-modal.modal-log @click="dataLog = item"><CIcon name="cil-info" /></b-button> -->
              </td>
            </template>
          </CDataTable>
        </b-col>
      </b-row>

      <div>
        <b-modal id="modal-foto" size="xs" centered scrollable title="Foto Absensi Karyawan" header-bg-variant="success" header-text-variant="light">
          <div v-if="!src1 && !src2" class="d-flex flex-column align-items-center justify-content-center text-center" style="min-height: 400px">
            <span class="text-muted mb-3" style="font-weight: 500">TIDAK ADA DATA FOTO</span>

            <div
              style="width: 300px; height: 300px; border-radius: 50%; border: 3px solid #ccc; display: flex; align-items: center; justify-content: center; overflow: hidden; background-color: #f9f9f9"
            >
              <img src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" alt="foto absen" style="width: 80%; height: 80%; object-fit: contain" />
            </div>

            <div class="mt-4">
              <small class="text-secondary">Foto Absensi Karyawan Tidak Tersedia</small>
            </div>
          </div>

          <div class="w-100 d-flex justify-content-even" v-else>
            <div class="w-100">
              <div class="row">
                <div class="col text-center">
                  <h5>Foto Absen</h5>
                </div>
              </div>
              <div class="row" v-if="src1">
                <div class="col text-center">
                  <img :src="src1" alt="foto absen" style="width: 300px; height: 300px" @error="onImageError" />
                </div>
              </div>
            </div>
            <!-- <div class="w-100">
              <div class="row">
                <div class="col text-center">
                   <h5>Foto Pulang</h5>
                </div>
              </div>
              <div class="row" v-if="src2">
                <div class="col">
                  <img :src="src2" alt="foto absen pulang" style="width: 300px; height: 300px" />
                </div>
              </div>
            </div> -->
          </div>
          <template #modal-footer>
            <b-button variant="secondary" @click="$bvModal.hide('modal-foto')"> Batal </b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <ModalTelat :dataEdit="dataEdit" :data="data" />
    <ModalLog :dataLog="dataLog" :data="data" />

    <template #modal-footer>
      <b-button variant="danger" @click="$bvModal.hide('modal-detail')"> Batal </b-button>
      <b-button variant="success" @click="$bvModal.show('modal-confirm')"> Print Absensi </b-button>
    </template>

    <div>
      <b-modal id="modal-confirm" centered title="Konfirmasi!" header-bg-variant="success" header-text-variant="light">
        <div class="d-flex">
          <div>
            <div class="row">
              <div class="col text-center">
                <span
                  ><h5>Download Absensi - {{ data.namaKaryawan }}</h5></span
                >
              </div>
            </div>
          </div>
        </div>
        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-confirm')"> Batal </b-button>
          <b-button variant="success" @click="printAbsensi()"> Print </b-button>
        </template>
      </b-modal>
    </div>
  </b-modal>
</template>
<script>
import ModalTelat from "./modalUpdate.vue";
import ModalLog from "./modalLog.vue";
export default {
  name: "tabAbsensiKedatangan",
  props: ["data", "bulan", "tahun", "detail", "fetch_data"],
  components: {
    ModalTelat,
    ModalLog,
  },
  data() {
    return {
      title: null,
      src1: "",
      src2: "",
      dataEdit: null,
      dataLog: null,
      items: [
        {
          no: "-",
          tanggal: "-",
          jamMasuk: "-",
          jamKeluar: "-",
        },
      ],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          _classes: "table-number text-center",
        },
        {
          key: "namaTanggalAbsen",
          label: "Tanggal",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "kategoriShift",
          label: "Jadwal",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "statusIjin",
          label: "Status Absensi",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "namaMasuk",
          label: "Jam Masuk Kerja",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "namaKeluar",
          label: "Jam Pulang",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "kodeDendaAbsen",
          label: "Denda",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "terlambat",
          label: "Total Menit",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  mounted() {
    // this.setPeriode();
  },
  methods: {
    viewImage(data) {
      let kode = this.$store.state.kode_client || null;
      if (kode === "shortcut") {
        kode = "shorcuthr";
      }
      const path = data.fotoAbsensi;
      const deadline = new Date("2025-10-10T12:00:00+07:00");
      let tanggalAbsen = new Date(data.tanggalAbsen);
      if (data.masuk) {
        const [hours, minutes, seconds] = data.masuk.split(":").map(Number);
        tanggalAbsen.setUTCHours(hours, minutes, seconds || 0, 0);
      }
      const now = tanggalAbsen;
      if (now < deadline) {
        if (!path.includes("/absensiKaryawanMobile/")) {
          return `${this.$be}api-${kode}/${path}`;
        } else {
          return `https://integrasia.storage.googleapis.com/${path}`;
        }
      }
      return `https://${kode}.storage.googleapis.com/${path}`;
    },
    onImageError(event) {
      event.target.src = "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg";
    },
    async getData() {
      let vm = this;
      vm.items = [];
      let absensi = await vm.$axios.post("absensiKaryawanMobile/listKedatanganByDataKaryawanId/", vm.fetch_data);
      // console.log("absensi", absensi, vm.fetch_data);
      vm.items =
        absensi.data.status == 200
          ? absensi.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                namaTanggalAbsen: vm.$moment(x.tanggalAbsen).format("LL"),
                namaMasuk: x.masuk ? vm.$moment(x.masuk, "HH:mm:ss").format("HH:mm") : " - ",
                namaKeluar: x.keluar ? vm.$moment(x.keluar, "HH:mm:ss").format("HH:mm") : " - ",
              };
            })
          : [];
    },
    async printAbsensi() {
      let vm = this;
      let kode = vm.$store.state.kode_client ? vm.$store.state.kode_client : null;
      let url = kode ? vm.$be + "api-" + kode + "/" : vm.$be;
      let x = `?dataKaryawanId=${vm.data.dataKaryawanId}&tglAwal=${vm.$moment(vm.fetch_data.tglAwal).format("YYYY-MM-DD")}&tglAkhir=${vm
        .$moment(vm.fetch_data.tglAkhir)
        .format("YYYY-MM-DD")}&namaKaryawan=${vm.data.namaKaryawan}&namaClient=${kode.toUpperCase()}`;
      window.open(url + "absensiKaryawanMobile/cetakAbsensi/" + x, "_blank");
      vm.$bvModal.hide("modal-confirm");
    },
  },
  watch: {
    detail: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.title = "Detail Absensi Karyawan " + this.data.namaKaryawan;
        this.getData();
      }
    },
  },
};
</script>
